module.exports = __webpack_public_path__ + "static/media/body_bg.fbff4029.jpg";